import { render, staticRenderFns } from "./LeisuresComponent.vue?vue&type=template&id=1b2738eb&scoped=true&"
import script from "./LeisuresComponent.vue?vue&type=script&lang=js&"
export * from "./LeisuresComponent.vue?vue&type=script&lang=js&"
import style0 from "./LeisuresComponent.vue?vue&type=style&index=0&id=1b2738eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2738eb",
  null
  
)

export default component.exports